import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {Grid} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { ModalHeader } from 'reactstrap';
import {Button} from '@material-ui/core'
import Orgnr from './Inputs/Orgnr'
import KundNamn from './Inputs/KundNamn'
import KundLNamn from './Inputs/KundLNamn'
import KundFNamn from './Inputs/KundFNamn'
import KundEmail from './Inputs/KundEmail'
import Adress from './Inputs/Adress'
import Postnr from './Inputs/Postnr'
import Ort from './Inputs/Ort'
import Tele from './Inputs/Tele'
import Kundnr from './Inputs/Kundnr'
import Type from './Inputs/Type'
import Distrikt from './Inputs/Distrikt'
import GetKund from './Inputs/GetKund'
import GenerateKundOrgnr from './Inputs/GenerateKundOrgnr'
import { withStyles } from '@material-ui/core/styles';
import { getnewKundByOrgnr,saveThisNewKund,onSetZeroKundSearch, getMinaDistriktPostnr } from 'actions'
import {isEmpty} from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import TaggarComponent from 'components/TaggarComponent'
import IntlMessages from 'util/IntlMessages';
import LandSelect from '../SkapaFaktura/Inputs/LandSelect'
import { injectIntl } from 'react-intl'; 

const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
function mapStateToProps({auth,accountsData}) {
    const { authUser} = auth;
    const { KundSearch,Flags,isCheckedOk} = accountsData;
    return {
        authUser,KundSearch,Flags,isCheckedOk
    };
}

function mapDispatchToProps(dispatch) {
    
    return {
        getnewKundByOrgnr: (userid,AFid,Orgnr) => dispatch(getnewKundByOrgnr(userid,AFid,Orgnr)),
        saveThisNewKund: (userid,AFid,Kund) => dispatch(saveThisNewKund(userid,AFid,Kund)),
        getMinaDistriktPostnr: (AFid,userid,post) => dispatch(getMinaDistriktPostnr(AFid,userid,post)),
        onSetZeroKundSearch:()=>dispatch(onSetZeroKundSearch()),

    };
}

class PopUpSkapaKund extends Component {
    state={
        open:this.props.open,
        KundSearch:{},
        isLoading:false,
        error:false,
        errorMessage:"",
        newKund:{
            taggar: [],
            Orgnr:"",
            KundNamn:"",
            Adress:"",
            Postnr:"",
            Ort:"",
            Tele:"",
            Kundnr:"",
            Type:"",
            Land:"Sverige",
            isAktiv:0,
            DistriktId:null
        }

    }
    componentDidMount=()=>{
        this.setState({
            open:this.props.open,
        })
    }
    componentDidUpdate=()=>{
        if(this.state.open !== this.props.open){
            if(this.props.open){
                const userid = this.props.authUser.user_id;
                const AFid = this.props.authUser.user_Afid;
                
                this.props.onSetZeroKundSearch()
                
                this.props.getMinaDistriktPostnr(AFid, userid, null)
            }
            this.setState({
                open:this.props.open
            })
        }

        if(this.state.KundSearch !== this.props.KundSearch){
            if(!isEmpty(this.props.KundSearch)){
                this.setState({
                    isLoading:false,
                })
            }
            this.setState({
                KundSearch:this.props.KundSearch, 
                error:false,    
                errorMessage:"",           
                newKund:{
                    ...this.state.newKund,
                    Orgnr:this.props.KundSearch.Orgnr,
                    KundNamn:this.props.KundSearch.KundNamn,
                    Adress:this.props.KundSearch.adress,
                    Postnr:this.props.KundSearch.postnr,
                    Ort:this.props.KundSearch.ort,
                    Tele:this.props.KundSearch.Telefonnummer,
                    Kundnr:parseInt(this.state.newKund.Type)=== 2?this.state.newKund.Kundnr:this.props.KundSearch.KundnrAf,
                    isAktiv:this.props.KundSearch.isAktiv,
                    DistriktId:null
                }
            })
        }
    }
    handleClose = () => {
        this.setState({
            open:false,
            KundSearch:{},
            isLoading:false,
            error:false,
            errorMessage:"",
            newKund:{
                taggar: [],
                Orgnr:"",
                isGenOrgnr:0,
                KundNamn:"",
                Adress:"",
                Postnr:"",
                Ort:"",
                Tele:"",
                Kundnr:"",
                Type:"",
                Land:"Sverige",
                isAktiv:0,
                DistriktId:null
            }
        })
        this.props.handleClose(false)
    }
    onCheckReq=(Meta,Value)=>{
        let error=false
        let errorMessage=<IntlMessages id="Incorrect.fields.error"/>
       
        if(Meta === "Orgnr"){
            if(Value < 8 || isEmpty(Value)){
                error=true
            }
        }
        if(Meta === "KundNamn"){
            if(isEmpty(Value)){
                error=true
            }
        }
        this.setState({
            error:error,
            errorMessage:errorMessage,
        })
    }
    onChangeKund=(Meta,Value)=>{
        this.onCheckReq(Meta,Value)
        console.log(Meta)
        console.log(Value)
        console.log(this.state.newKund)
        if(Meta === "Orgnr"){
            this.setState({
                newKund:{
                    ...this.state.newKund,
                    [Meta]:Value,
                    isGenOrgnr:0
                }
            })
        }
        else{
        this.setState({
            newKund:{
                ...this.state.newKund,
                [Meta]:Value
            }
        })
        }
    }
    getThisKundByOrgnr=()=>{
        this.setState({isLoading:true})
        const Orgnr = this.state.newKund.Orgnr;
        const userid = this.props.authUser.user_id;
        const AFid = this.props.authUser.user_Afid;
        this.props.getnewKundByOrgnr(userid,AFid,Orgnr)
        
    }
    savethisNewKund=()=>{
        if(!this.state.error){
        const userid = this.props.authUser.user_id;
        const AFid = this.props.authUser.user_Afid;
        const Kund = this.state.newKund
        console.log(Kund)
        
        this.props.saveThisNewKund(userid,AFid,Kund)
        this.setState({
            open:false,
            KundSearch:{},
            isLoading:false,
            error:false,
            newKund:{
                Orgnr:"",
                isGenOrgnr:0,
                KundNamn:"",
                KundLNamn:"",
                Adress:"",
                Postnr:"",
                Ort:"",
                Tele:"",
                Email:"",
                Kundnr:"",
                Land:"Sverige",
                Type:"",
                isAktiv:0,
                DistriktId:null
            }
        })
        /**/
        this.props.handleClose(false)
        }
    }
    generateKundByOrgnr=()=>{
        let GeOrg = Math.floor(Math.random() * 10000000000000);
        this.setState({
            ...this.state,
            newKund:{
                ...this.state.newKund,
                Orgnr:GeOrg.toString(),
                isGenOrgnr:1
            }
        })
    }
    render() {
        const { fullScreen } = this.props;
        const Countrylabel = this.props.intl.formatMessage({ id: 'Country' });
        console.log(Countrylabel,"Countrylabel")
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title"
            fullScreen={fullScreen}
             open={this.state.open} fullWidth={true}
        maxWidth={"xs"} 
        disableBackdropClick={true} 
        >
        <ModalHeader className="modal-box-header bg-primary text-white">
            <IntlMessages id="Label.NewCustomer"/>
            <IconButton className="text-white"
                onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </ModalHeader>
        <DialogContent dividers className='px-4'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Type
            Type={this.state.newKund.Type}
            Flags={this.props.Flags}
            onChangeKund={this.onChangeKund}
            />
          </Grid> 
          <Grid item xs={8}>
                <Orgnr
                Type={this.state.newKund.Type}
                Orgnr={this.state.newKund.Orgnr}
                onChangeKund={this.onChangeKund}
                />
                </Grid> 
        {
              
          <Grid item xs={4}>
                {
                (isEmpty(this.state.newKund.Orgnr) ||
                this.state.newKund.Orgnr.length < 8 )?
                <GenerateKundOrgnr
                generateKundByOrgnr={this.generateKundByOrgnr}
                />
                :parseInt(this.state.newKund.Type) === 0?
            ""
            :  
                <GetKund
                    isDisabeled={isEmpty(this.state.newKund.Orgnr)}
                    getThisKundByOrgnr={this.getThisKundByOrgnr}
                />
                }
                </Grid> 
        }
        {  
        this.state.isLoading===true?
        <CircularProgress />
        :
        <>
            {
                parseInt(this.state.newKund.Type) === 0?
                <>
                <Grid item xs={6}>
                    <KundFNamn
                    Type={this.state.newKund.Type}
                    KundFNamn={this.state.newKund.KundNamn}
                    onChangeKund={this.onChangeKund}
                    />
                    </Grid> 
                <Grid item xs={6}>
                    <KundLNamn
                    Type={this.state.newKund.Type}
                    KundLNamn={this.state.newKund.KundLNamn}
                    onChangeKund={this.onChangeKund}
                    />
                    </Grid> 
                </>
                :
                <Grid item xs={12}>
                    <KundNamn
                    Type={this.state.newKund.Type}
                    KundNamn={this.state.newKund.KundNamn}
                    onChangeKund={this.onChangeKund}
                    />
                    </Grid> 
            }       
            <Grid item xs={12}>
                <Adress
                Adress={this.state.newKund.Adress}
                onChangeKund={this.onChangeKund}
                />
                </Grid> 
            <Grid item xs={6}>
                <Postnr
                Postnr={this.state.newKund.Postnr}
                onChangeKund={this.onChangeKund}
                />
                </Grid> 
            <Grid item xs={6}>
                <Ort
                Ort={this.state.newKund.Ort}
                onChangeKund={this.onChangeKund}
                />
                </Grid> 
            {/*Land*/}
            <Grid item xs={12}>
               <LandSelect
                disabled={false}
                 onCahngeHandel={(e)=>{
                    this.setState({
                        newKund:{
                            ...this.state.newKund,
                            Land:e.target.value
                        }
                    })

                   // props.onChangeKund(e)
                }}
                label={Countrylabel}
                name={"Land"}
                Value={this.state.newKund.Land}
               /> 
            </Grid>
            <Grid item xs={6}>
                <Tele
                Tele={this.state.newKund.Tele}
                onChangeKund={this.onChangeKund}
                />
                </Grid> 
            <Grid item xs={6}>
                <Kundnr
                Afid={this.props.authUser.user_Afid}
                Kundnr={this.state.newKund.Kundnr}
                onChangeKund={this.onChangeKund}
                />
                </Grid> 
                {
                  parseInt(this.props.Flags?.Distrikt) === 1 &&
                  <Grid item xs={12}>
                  <Distrikt
                  DistriktId={this.state.newKund.DistriktId}
                  onChangeKund={this.onChangeKund}
                  />
                  </Grid> 
                }
        {
            parseInt(this.state.newKund.Type) === 0?
            <KundEmail
            Email={this.state.newKund.Email}
            onChangeKund={this.onChangeKund}
            />
            :""
        }
        <Grid item xs={12}>
            <TaggarComponent
              Source={1}
              onChange={(taggar) => this.onChangeKund('taggar', taggar)}
            />
            </Grid> 
        </>}
        </Grid>
        {
            this.state.error? 
            <Alert severity="warning">{this.state.errorMessage}</Alert>
            :""
        }
        {
            parseInt(this.state.newKund.isAktiv) === 1 && parseInt(this.state.newKund.Type) !== 2?
            <Alert severity="warning">Kunden finns redan</Alert>
            :""
        }
        </DialogContent>
        <DialogActions>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                >
                <div>
                    <Button onClick={this.handleClose} variant="outlined" color="default" 
                    className="jr-btn">
                        <IntlMessages id="Cancel"/>
                    </Button>
                </div>
                <div className="ml-auto">
                  <Button
                    color="primary"
                    className="jr-btn"
                    variant="contained"
                    disabled={
                        isEmpty(this.state.newKund.Orgnr) ||
                        this.state.newKund.Orgnr.length <8 ||
                        isEmpty(this.state.newKund.KundNamn) ||
                        parseInt(this.props.isCheckedOk) === 1 ||
                       ( parseInt(this.state.newKund.isAktiv) === 1 && parseInt(this.state.newKund.Type) !== 2 )

                    }
                    onClick={this.savethisNewKund}
                    >
                   <IntlMessages id="Create"/>
                    </Button>
                    </div>
                    </Grid>
        </DialogActions>
    </Dialog> 
        );
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)((withMediaQuery([
    ['fullScreen', theme => theme.breakpoints.down('xs'), {
      defaultMatches: true
    }]
  ]))(injectIntl(PopUpSkapaKund)));



